/* bloom-cart-summary.js — delivery reassurance above the checkout button.
 *
 * READS THE CANONICAL KEYS, IN ANY LOCALE
 * Properties are matched through window.BloomDetailsKeys (bloom-details-keys
 * .liquid), which lists the key names for every storefront language — so a
 * line added in German is still understood in an English cart. The date is
 * re-formatted here from _delivery_iso, the one hidden machine key; the window
 * is read from the visible window property (it already says 13:00–18:00) with
 * the shop's slot metafield as a fallback for lines that predate this build.
 *
 * Shown: when it arrives, who receives it. Nothing else. Per-line details and
 * the Edit button under each item are bloom-details.js's job.
 */
(function () {
  var host = document.getElementById('bloom-cart-summary');
  if (!host) return;

  var cfgEl = document.querySelector('[data-bl-cart-config]');
  var C = { t: {} };
  if (cfgEl) { try { C = JSON.parse(cfgEl.textContent); } catch (e) {} }
  var T = C.t || {}, SLOTS = C.slots || [], LOCALE = C.locale || 'en';

  function routeRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function slotLabel(id) {
    for (var i = 0; i < SLOTS.length; i++) {
      if (SLOTS[i].id === id) return SLOTS[i].from + '–' + SLOTS[i].to;
    }
    return '';
  }

  function dateLabel(iso) {
    var d = new Date(iso + 'T12:00:00Z');
    var opts = { weekday: 'long', day: 'numeric', month: 'long' };
    try { return new Intl.DateTimeFormat(LOCALE, opts).format(d); }
    catch (e) { return new Intl.DateTimeFormat('en', opts).format(d); }
  }

  var KEYS = window.BloomDetailsKeys || {};
  function pick(p, fieldName) {
    var ls = Object.keys(KEYS);
    for (var i = 0; i < ls.length; i++) {
      var k = KEYS[ls[i]] && KEYS[ls[i]][fieldName];
      if (k && p[k]) return p[k];
    }
    return '';
  }

  function windowOf(p) {
    return pick(p, 'window') || slotLabel(p._delivery_slot);
  }

  function when(item) {
    var p = item.properties || {};
    if (!p._delivery_iso) return '';
    var s = windowOf(p);
    return s ? dateLabel(p._delivery_iso) + ' · ' + s : dateLabel(p._delivery_iso);
  }

  function recipient(item) {
    var p = item.properties || {};
    if (p._bloom_details) { // lines added before this build
      try { return (JSON.parse(p._bloom_details).recipient || '').trim(); } catch (e) {}
    }
    return (pick(p, 'recipient') || '').trim();
  }

  function signature(item) {
    var p = item.properties || {};
    return (p._delivery_iso || '') + '|' + windowOf(p);
  }

  function paint(cart) {
    host.textContent = '';
    if (!cart || !cart.items || !cart.items.length) { host.hidden = true; return; }

    var dated = cart.items.filter(function (i) { return when(i); });

    if (!dated.length) {
      host.hidden = false;
      var warn = el('div', 'bl-csum bl-csum--empty');
      warn.appendChild(el('p', 'bl-csum__missing', T.missing || ''));
      host.appendChild(warn);
      return;
    }

    host.hidden = false;
    var panel = el('div', 'bl-csum');

    var lead = el('p', 'bl-csum__lead');
    lead.innerHTML = C.icon || '';
    lead.appendChild(el('span', null, T.heading || ''));
    panel.appendChild(lead);

    var sigs = {};
    dated.forEach(function (i) { sigs[signature(i)] = true; });

    if (Object.keys(sigs).length === 1) {
      panel.appendChild(el('p', 'bl-csum__when', when(dated[0])));
      var who = recipient(dated[0]);
      if (who) {
        panel.appendChild(el('p', 'bl-csum__who',
          T.forWord ? T.forWord + ' ' + who : who));
      }
    } else {
      // Genuinely different delivery days in one cart is rare, but showing only
      // the first one silently would be worse than a little extra text.
      var list = el('ul', 'bl-csum__multi');
      dated.forEach(function (i) {
        var li = el('li');
        li.appendChild(el('span', 'bl-csum__mtitle', i.product_title));
        li.appendChild(el('span', 'bl-csum__mwhen', when(i)));
        list.appendChild(li);
      });
      panel.appendChild(list);
    }

    host.appendChild(panel);
  }

  var inflight = false;
  function refresh() {
    if (inflight) return;
    inflight = true;
    fetch(routeRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(paint)
      .catch(function () {})
      .then(function () { inflight = false; });
  }

  /* The theme repaints .js-mini-cart-content on every cart mutation. Watching
   * that single node for childList changes is the cheapest reliable signal;
   * the timeout debounces bursts so this never fires per inserted node. */
  var target = document.querySelector('.js-mini-cart-content');
  if (target) {
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(refresh, 180);
    }).observe(target, { childList: true });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-toggle-cart')) setTimeout(refresh, 220);
  });

  refresh();
})();
